(() => {
  const PROMPT = 'Select options';
  const FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';

  function state(form) {
    const root = form.closest('[id^="shopify-section"]') || document;
    const picker = root.querySelector('variant-selects, variant-radios');
    if (!picker) return null;

    const selects = [...picker.querySelectorAll('select')];
    const fieldsets = [...picker.querySelectorAll('fieldset')];
    const total = selects.length + fieldsets.length;
    const chosen =
      selects.filter((s) => s.value !== '').length +
      fieldsets.filter((f) => f.querySelector('input:checked')).length;

    return { total, chosen, complete: total > 0 && chosen === total };
  }

    function guard(name) {
        customElements.whenDefined(name).then(() => {
        const proto = customElements.get(name).prototype;
        if (!proto.toggleAddButton || proto.__selectionGuarded) return;

        const original = proto.toggleAddButton;
        proto.toggleAddButton = function (disable, text, modifyClass) {
            const sectionId = this.dataset.section || this.dataset.originalSection;
            const form = document.getElementById(`product-form-${sectionId}`);
            const s = form ? state(form) : null;
            if (s && !s.complete) return original.call(this, true, PROMPT, modifyClass);
            return original.call(this, disable, text, modifyClass);
        };
        proto.__selectionGuarded = true;
        });
    }

    ['variant-selects', 'variant-radios', 'product-info'].forEach(guard);

    function apply(form) {
        const s = state(form);
        if (!s) return;

        const section = form.closest('[id^="shopify-section"]');
        if (s.complete) {
        section?.removeAttribute('data-selection-incomplete');
        return;
        }
        section?.setAttribute('data-selection-incomplete', '');

        const button = form.querySelector('[name="add"]');
        if (!button) return;
        const label = button.querySelector('span');
        const idInput = form.querySelector('input[name="id"]');

        button.setAttribute('disabled', 'disabled');
        if (label && label.textContent.trim() !== PROMPT) label.textContent = PROMPT;
        if (idInput && idInput.value !== '') idInput.value = '';
    }
  const refresh = () => document.querySelectorAll(FORM_SELECTOR).forEach(apply);

  document.addEventListener('change', refresh);
  document.addEventListener(
    'submit',
    (e) => {
      if (!e.target.matches?.(FORM_SELECTOR)) return;
      const s = state(e.target);
      if (s && !s.complete) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  new MutationObserver(() => requestAnimationFrame(refresh)).observe(document.body, {
    childList: true,
    subtree: true,
  });

  refresh();
})();